import React from 'react';

import { useI18n } from 'i18n/I18nContext';

export type LanguageSwitcherVariant = 'default' | 'onDark';

export interface LanguageSwitcherProps {
  className?: string;
  /** Segmented control for dark or green backgrounds */
  variant?: LanguageSwitcherVariant;
}

const LanguageSwitcher = ({ className = '', variant = 'default' }: LanguageSwitcherProps) => {
  const { t, locale, switchLocale } = useI18n();
  const rootClass = [
    'gb-lang',
    variant === 'onDark' ? 'gb-lang--on-dark' : 'gb-lang--default',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} role="group" aria-label={t('footer.language')}>
      <button
        type="button"
        className={locale === 'en' ? 'gb-lang__btn is-active' : 'gb-lang__btn'}
        onClick={() => switchLocale('en')}
        aria-pressed={locale === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        className={locale === 'nl' ? 'gb-lang__btn is-active' : 'gb-lang__btn'}
        onClick={() => switchLocale('nl')}
        aria-pressed={locale === 'nl'}
      >
        NL
      </button>
    </div>
  );
};

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher.tsx